const behaviorWithDogs = [
    { value: 'friendly', label: { en: 'Friendly', es: 'Amistoso' } },
    { value: 'tolerant', label: { en: 'Tolerant', es: 'Tolerante' } },
    { value: 'dominant', label: { en: 'Dominant', es: 'Dominante' } },
    { value: 'territorial', label: { en: 'Territorial', es: 'Territorial' } },
    { value: 'fearful', label: { en: 'Fearful', es: 'Miedoso' } },
    { value: 'aggressive', label: { en: 'Aggressive', es: 'Agresivo' } },
    { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
];

export default behaviorWithDogs;